module.exports = __webpack_public_path__ + "img/BusinessCenter.f66e6f06.png";